// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"570ccabb","453":"fd5568fb","455":"61011c78","977":"d1146762"}[chunkId] + ".chunk.js";
};